import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, TextField, Box } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "../Dialog";
import { handleError } from "../../reducers/ErrorReducer";
import {
  findSecCode,
  getProfile,
  updateProfile,
} from "../../pages/Security/SecFunction";
import Autocomplete2 from "../Autocomplete2";
import { notify } from "../../reducers/NotifierReducer";
import { closeEditSecProfile } from "../../reducers/DialogsReducer";
import { notifyDataUpdate } from "../../reducers/DataUpdateReducer";

const AddSecProfileDialog = (props) => {
  const { profileId } = props;
  const [name, setName] = useState("");
  const [currentType, setCurrentType] = useState(null);
  const [allTypes, setAllTypes] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const types = await findSecCode("profiletype");
    setAllTypes(types);
    const profile = await getProfile(profileId);
    setName(profile.Label);
    const curType = types.find((type) => type.Code === profile.Type);
    setCurrentType(curType || null);
  };

  const close = () => {
    props.closeEditSecProfile();
  };

  const save = async () => {
    const data = {
      Label: name,
      Type: currentType?.Code || null,
    };
    try {
      await updateProfile(profileId, data);
      props.notifyDataUpdate({ type: "edit-profile", data: profileId });
      props.notify("Profile Updated", "success");
      props.closeEditSecProfile();
    } catch (err) {
      props.handleError(err, "Error Updating Profile");
    }
  };

  const renderActions = () => (
    <>
      <Button
        color="primary"
        variant="contained"
        onClick={save}
        disabled={!name}
        startIcon={<SaveIcon />}
      >
        Save
      </Button>
      <Button color="inherit" onClick={close} startIcon={<CloseIcon />}>
        Close
      </Button>
    </>
  );

  const renderName = () => (
    <TextField
      label="Profile Name"
      variant="outlined"
      value={name}
      size="small"
      onChange={(e) => setName(e.target.value)}
      fullWidth
      sx={{ mb: 2 }}
    />
  );

  const renderType = () => {
    const handleChange = (e, newValue) => setCurrentType(newValue);
    return (
      <Box mt={2}>
        <Autocomplete2
          options={allTypes}
          onChange={handleChange}
          value={currentType}
          label="Profile Type"
          getOptionLabel={(option) => option.Code}
          isOptionEqualToValue={(option, value) => option.Code === value.Code}
          renderOption={(props, option) => (
            <li {...props}>
              {option.Code}{" "}
              {option.Description ? `- ${option.Description}` : ""}
            </li>
          )}
        />
      </Box>
    );
  };

  return (
    <Dialog onClose={close} title="Edit Profile" actions={renderActions()}>
      <Box>
        {renderName()}
        {renderType()}
      </Box>
    </Dialog>
  );
};

export default connect(null, {
  closeEditSecProfile,
  handleError,
  notify,
  notifyDataUpdate,
})(AddSecProfileDialog);
